export default __webpack_public_path__ + "static/media/fbtimeline.988ecdd3.svg";